import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, DotGroup } from 'pure-react-carousel';
import Carousel from 'pure-react-carousel/dist/react-carousel.es.css';

/**
 * Slider
 */
const TemplateCarouselSlider = ({ boxStyle, slideBoxSet, contentSet, contentCount }) => {
  const items = [];
  // set
  const [visibleSlides, setVisibleSlides] = useState(1);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [arrowCircleHeight, setArrowCircleHeight] = useState();
  const [divMsgId, setDivMsgId] = useState();
  const [focusedName, setFocusedName] = useState(null);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  
  const slideBoxSize = slideBoxSet.width + slideBoxSet.margin * 2;
  const messageBoxDef = useRef(0);

  const setHeight = (ref) => {   
    const temp = [];
    if(ref !==null && arrowCircleHeight <=500) {
	    setArrowCircleHeight(arrowCircleHeight - 18);
     }
  };

  const reRenderStyle = { height: arrowCircleHeight, display:'none' } 
  const setArrowHeight = (ref) => {
    const temp = [];
    if(ref !==null && arrowCircleHeight <=500) {
      // ref.clientHeight = arrowCircleHeight - 18;
     }
  };
  
  const handleClick = (e) => {
    const msgDiv = e.target.closest('div[name]');
    const msgId = msgDiv.getAttribute('name');
    setDivMsgId(msgId);
    setTriggerUpdate(true);
  }
  
  const updateTabIndexes = () => {
    const divId = divMsgId || focusedName;
    if (divId) {
      const msgDivElement =document.querySelector('div[name="'+divId+'"]');
      const liElements = msgDivElement.querySelectorAll('li[index]');
      const dotGroupElements = msgDivElement.getElementsByClassName('_dot_group');
        
      liElements.forEach((li, liIdx) => {
        const index = parseInt(li.getAttribute('index'), 10);
        
        const buttons = li.querySelectorAll('button');    
        buttons.forEach((button, btnIdx) => {
          button.tabIndex = index === currentSlide ? 0 : -1;
        });
      });
      
      if (dotGroupElements.length > 0) {
        Array.from(dotGroupElements).forEach((dotGroup) => {
          const dotButtons = dotGroup.querySelectorAll('button');
          
          dotButtons.forEach((button, index) => {
            button.setAttribute('title', index === currentSlide ? '선택됨' : `Slide ${index + 1}`);
            button.addEventListener('click', (e) => {
              setCurrentSlide(index);
              // handleClick(e);
            });
          });
        });
      }
    }
  };
  
  useLayoutEffect(() => {
    let clientWidth = messageBoxDef.current.clientWidth;
    setVisibleSlides(clientWidth / slideBoxSize);  
    function handleResize(a) {
      clientWidth = messageBoxDef.current.clientWidth;
      setVisibleSlides(clientWidth / slideBoxSize);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => { 
    const handleFocus = () => {
      // 현재 포커스된 요소 가져오기
      const activeElement = document.activeElement;

      if (activeElement) {
        const closestDiv = activeElement.closest('div[name]');
        if (closestDiv) {
          const nameValue = closestDiv.getAttribute('name');
          setFocusedName(nameValue);
          
          const buttonDiv = closestDiv.querySelector('div._carousel_button_div');
          if (buttonDiv) {
            setTriggerUpdate(true);
          }
        }
      }
    };
    
    window.addEventListener('focusin', handleFocus);

    return () => {
      window.removeEventListener('focusin', handleFocus);
    };
  }, [currentSlide]);

  useEffect(() => { 
    if (triggerUpdate) {
      updateTabIndexes();
      setTriggerUpdate(false); // 상태 초기화
    }
  }, [triggerUpdate]);
  
  return (
    <div 
      className="_carousel_div" 
      ref={messageBoxDef}
    >
      <CarouselProvider  
        className="_message_temp_carousel_div"        
        naturalSlideWidth={100}
        naturalSlideHeight={0}
        visibleSlides={1}
        totalSlides={contentCount}
        currentSlide={currentSlide}
        step={1}
        dragStep={1}
      >
      
        {contentCount > 1 && (
          <>
            <ButtonBack 
              className="_back_button" 
              aria-label="이전 콘텐츠 보기" 
              onClick={(e) => { setCurrentSlide((currentSlide - 1 + contentCount) % contentCount); handleClick(e); }}
            >
              <i className="ri-arrow-left-circle-fill" />
            </ButtonBack>
          </>
        )}
        
        <Slider 
          aria-live="off" 
          ariaLabel="콘텐츠 목록" 
          className="carousel-item"
        >
          {contentSet(setArrowCircleHeight)}
        </Slider>
        {/* Conditionally render the buttons based on isMouseOver state */}
        
        {contentCount > 1 && (
          <>
            <ButtonNext 
              className="_next_button" 
              aria-label="다음 콘텐츠 보기" 
              onClick={(e) => { setCurrentSlide((currentSlide + 1) % contentCount); handleClick(e); }}
            >
              <i className="ri-arrow-right-circle-fill"/>
            </ButtonNext>
            <DotGroup className="_dot_group" role="tablist"/>
          </>
        )}
      </CarouselProvider>
    </div>
  );
};

TemplateCarouselSlider.propTypes = {
  boxStyle: PropTypes.object,
  slideBoxSet: PropTypes.object,
  contentCount: PropTypes.number,
  contentSet: PropTypes.func,
};
TemplateCarouselSlider.defaultProps = {
  boxStyle: {},
  slideBoxSet: { width: 300, margin: 15, height: '200px' },
  contentCount: 0,
  contentSet: () => {},
};

export default TemplateCarouselSlider;
